import React from 'react';
import { ChartBarIcon, ArrowTrendingUpIcon, MagnifyingGlassIcon, BellAlertIcon } from '@heroicons/react/24/outline';

export default function RankTracking() {
    const features = [
        { icon: MagnifyingGlassIcon, title: 'Keyword Position Tracking', desc: 'Monitor your keyword rankings across Google, Bing, and other search engines in real time.' },
        { icon: ChartBarIcon, title: 'Historical Rank Data', desc: 'View ranking trends over time with interactive charts and detailed position history.' },
        { icon: ArrowTrendingUpIcon, title: 'Competitor Comparison', desc: 'Track how your rankings stack up against competitors for the same keywords.' },
        { icon: BellAlertIcon, title: 'Rank Change Alerts', desc: 'Get notified when your keywords move up or down significantly in search results.' }
    ];

    return (
        <>
            <div style={{ minHeight: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
                <div style={{ maxWidth: '720px', width: '100%', textAlign: 'center' }}>
                    {/* Coming Soon Badge */}
                    <div style={{
                        display: 'inline-flex', alignItems: 'center', gap: '8px',
                        background: 'linear-gradient(135deg, rgba(139,92,246,0.15), rgba(236,72,153,0.15))',
                        border: '1px solid rgba(139,92,246,0.3)', borderRadius: '24px',
                        padding: '8px 20px', marginBottom: '24px'
                    }}>
                        <div style={{
                            width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#8b5cf6',
                            animation: 'pulse 2s ease-in-out infinite'
                        }} />
                        <span style={{ color: '#8b5cf6', fontWeight: '600', fontSize: '14px', letterSpacing: '0.05em' }}>COMING SOON</span>
                    </div>

                    <h1 style={{ color: '#8b5cf6', fontSize: '36px', fontWeight: '700', marginBottom: '16px', lineHeight: '1.2' }}>
                        Rank Tracking
                    </h1>
                    <p style={{ color: '#8b5cf6', fontSize: '18px', lineHeight: '1.6', marginBottom: '48px', maxWidth: '560px', margin: '0 auto 48px' }}>
                        We're building a powerful rank tracking tool to help you monitor your search engine positions. Stay tuned  it's almost ready!
                    </p>

                    {/* Feature Cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '48px' }}>
                        {features.map((f, i) => (
                            <div key={i} style={{
                                background: 'rgba(30, 30, 60, 0.6)', border: '1px solid rgba(139,92,246,0.15)',
                                borderRadius: '12px', padding: '24px', textAlign: 'left',
                                transition: 'border-color 0.2s'
                            }}>
                                <f.icon style={{ width: '32px', height: '32px', color: '#8b5cf6', marginBottom: '12px' }} />
                                <h3 style={{ color: '#ffffff', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>{f.title}</h3>
                                <p style={{ color: '#94a3b8', fontSize: '14px', lineHeight: '1.5', margin: 0 }}>{f.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* Notify section */}
                    <div style={{
                        background: 'rgba(30, 30, 60, 0.4)', border: '1px solid rgba(139,92,246,0.2)',
                        borderRadius: '12px', padding: '24px'
                    }}>
                        <p style={{ color: '#cbd5e1', fontSize: '15px', margin: 0 }}>
                            Want to be notified when Rank Tracking launches?{' '}
                            <a href="mailto:info@serpfinity.ai" style={{ color: '#8b5cf6', textDecoration: 'none', fontWeight: '500' }}>
                                Contact us at info@SERPfinity.ai
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }`}</style>
        </>
    );
}
